/**
 * Límites del chat de IA compartidos por el servidor (api/chat.ts) y el cliente (contador de caracteres).
 * Módulo mínimo a propósito: NO importar aquí el prompt ni las guías (no deben viajar en el bundle del cliente).
 */

/**
 * Máximo de caracteres de una pregunta al chat.
 * 3 000 ≈ 800–900 tokens: una consulta contable con contexto, o un asiento / párrafo pegado, cabe de sobra.
 * Antes 1 500: se quedaba corto al pegar un caso con detalle. El costo máximo por consulta sube ≈ US$0.0014 (Sonnet)
 * / US$0.0005 (Haiku) respecto del tope anterior.
 */
export const MAX_QUESTION_CHARS = 3000;

export type ChatLang = 'es' | 'en';

export function normalizeLang(lang: unknown): ChatLang {
  return lang === 'en' ? 'en' : 'es';
}

/** Mensaje claro cuando la pregunta supera el tope. Nunca se recorta ni se envía vacía: se pide resumirla. */
export function questionTooLongMessage(length: number, lang: ChatLang = 'es'): string {
  return lang === 'en'
    ? `Your question is too long (${length} characters). Please shorten it to at most ${MAX_QUESTION_CHARS} characters and try again.`
    : `Tu pregunta es muy larga (${length} caracteres). Resúmela a un máximo de ${MAX_QUESTION_CHARS} caracteres e inténtalo de nuevo.`;
}
